import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Store } from '../Store';
import setupInterceptorsAndGetAxios from '../axiosRequest';

export default function useAxios() {
  const { dispatch: ctxDispatch, state } = useContext(Store);
  const { userInfo } = state;

  const navigate = useNavigate();

  return setupInterceptorsAndGetAxios(navigate, ctxDispatch, userInfo);
}
